import type { SupportedCurrencies } from 'types/currencies'

export const DescribeSwitcherCurrency: { [key: string]: boolean } = {
  SC: true,
  GC: false,
}

export const CurrencyToProductMode: Partial<Record<SupportedCurrencies, string>> = {
  SC: 'sweepstake',
  GC: 'gold',
}

export const ProductModeToCurrency: Record<string, SupportedCurrencies> = {
  sweepstake: 'SC',
  gold: 'GC',
}

export const showSweepstakeCurrencySymbol = (currency: SupportedCurrencies) => {
  return `${currency} `
}

export const IS_FIRST_TIME_GLOBAL_SWITCH = 'IS_FIRST_TIME_GLOBAL_SWITCH'
export const IS_FIRST_TIME_DIALOG_SWITCH = 'IS_FIRST_TIME_DIALOG_SWITCH'
